module.exports = __webpack_public_path__ + "static/venti2-banner-4e3b65049aa389112ba0b555bbd8cfa1.png";